/* eslint-disable camelcase */
// import { v1 as uuidv1 } from 'uuid';

import {
	getPlatform,
	get_cs_sid,
	get_cs_vid,
	iosOrAndroid,
	isMobileApp,
	isWeb,
} from "./utility";
import ENV from "../Environments";
import { ENVIRONMENT, SessionStorageKeys, ACCESS_TOKEN_KEY } from "./constants";

import * as utils from "./utility";
import { nativeApiInstance } from "./nativeApi";
import { v1 as uuidv1 } from "uuid";
import { isLocalStorageSupported } from "../utils/utility";

class Interceptor {
	nativeInstance() {
		return nativeApiInstance;
	}

	async getScreenDensity() {
		// return this.nativeInstance().getScreenDensity();
	}

	async generateHeaders(data) {
		let headers = {};
		try {
			if (
				[ENVIRONMENT.PROD, ENVIRONMENT.QA_PROD, ENVIRONMENT.DEV].includes(
					ENV.getEnvironment()
				)
			) {
				if (!utils.isWeb()) {
					headers = await this.nativeInstance().getHeaders(data);
				} else {
					if (
						isLocalStorageSupported() &&
						localStorage.getItem(ACCESS_TOKEN_KEY)
					) {
						headers["z-access-token"] =
							localStorage.getItem(ACCESS_TOKEN_KEY) || "";
					}
				}
			}
			if (headers) {
				headers["x-bsy-os"] = getPlatform();
				const correlationId = uuidv1();
				headers["Content-Type"] = "application/json";
				headers["Cache-Control"] = "no-store";
				headers.platform = getPlatform();
				headers.visitID = get_cs_sid();
				headers.uniqueTracking = correlationId;

				headers["x-visit-id"] = get_cs_sid();
				headers["x-visitor-id"] = get_cs_vid();
				headers["x-correlation-id"] = correlationId;
				headers.correlationId = correlationId;
				const appVersion = await this.getAppVersion();
				headers.appVersion = this.parseAppVersion(appVersion);
			}
		} catch (ex) {
			console.error(ex);
		}
		return headers;
	}

	parseAppVersion(appVersion) {
		try {
			if (appVersion) {
				const versionArr = appVersion.split(".");
				let major = "";
				let minor = "";
				let release = "";
				let version = "";
				major = versionArr[0];
				if (versionArr[1]) {
					minor = versionArr[1];
					if (versionArr[1].length === 1) {
						minor = "0" + versionArr[1];
					}
				} else {
					minor = "00";
				}
				if (versionArr[2]) {
					if (versionArr[2].indexOf("(") > -1) {
						release = versionArr[2].substr(0, versionArr[2].indexOf("("));
						if (release.length === 1) {
							release = "0" + release;
						}
					} else {
						release = versionArr[2];
						if (versionArr[2].length === 1) {
							release = "0" + versionArr[2];
						}
					}
				} else {
					release = "00";
				}
				version = major + minor + release;
				return Number(version);
			}
		} catch (ex) {
			return null;
		}
		return null;
	}

	sendBranchAnalyticsEvent(eventName, payload) {
		if (isMobileApp() && iosOrAndroid() === "ANDROID") {
			try {
				this.nativeInstance().sendBranchAnalytics({
					eventName,
					payload,
				});
			} catch (e) {
				console.error(e);
			}
		}
	}

	async getSessionId() {
		let sessionId = "";
		if (!isWeb()) {
			try {
				sessionId = await this.nativeInstance().getSessionId();
			} catch (ex) {
				console.error(ex);
			}
		}
		return sessionId;
	}

	async closeWebView() {
		if (isMobileApp()) {
			await this.nativeInstance().close();
		}
	}

	logHanselEvent(eventName, eventProps) {
		this.nativeInstance().logHanselEvent(eventName, eventProps);
	}

	async getVisitorId() {
		let visitorId = "";
		try {
			const storedVisitId = sessionStorage.getItem(
				SessionStorageKeys.VisitorId
			);
			if (storedVisitId) {
				return storedVisitId;
			}
			visitorId = await this.nativeInstance().getVisitorId();
			visitorId &&
				sessionStorage.setItem(SessionStorageKeys.VisitorId, visitorId);
		} catch (ex) {
			console.error(ex);
		}
		return visitorId;
	}

	async getAppVersion() {
		let appVersion = "";
		try {
			const storedAppVersion = sessionStorage.getItem(
				SessionStorageKeys.AppVersion
			);
			if (storedAppVersion) {
				return storedAppVersion;
			}
			appVersion = await this.nativeInstance().getAppVersion();
			appVersion &&
				sessionStorage.setItem(SessionStorageKeys.AppVersion, appVersion);
		} catch (ex) {
			console.error(ex);
		}
		return appVersion;
	}

	async getHeaderVersion() {
		let headerVersion;
		try {
			if (isMobileApp()) {
				headerVersion = await this.nativeInstance().getHeaderVersion();
			}
		} catch (ex) {
			console.error(ex);
		}
		return headerVersion;
	}

	copyToClipBoard(text) {
		try {
			if (isMobileApp()) {
				this.nativeInstance().copyToClipBoard(text);
			}
		} catch (ex) {
			console.error(ex);
		}
	}
}

function interceptorInstance() {
	return new Interceptor();
}

export default interceptorInstance;
